import { Route, Routes } from 'react-router-dom'
import NeedsAttentionPage from './Page'
import AcceptDraftForm from './AcceptDraftForm'

export default function NeedsAttentionIndex() {
  return (
    <Routes>
      <Route path="/*" element={<NeedsAttentionPage />} />
      <Route path="/:id" element={<NeedsAttentionPage />} />
      <Route path="/:id/assign" element={<NeedsAttentionPage />} />
      <Route path="/:id/transfer" element={<NeedsAttentionPage />} />
      <Route path="/:id/accept" element={<AcceptDraftForm />} />
    </Routes>
  )
}
